"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatTweetDate = exports.formatTimeShort24hrs = exports.formatTimeShort = exports.formatTimeOrDateShort = exports.formatTimeLong = exports.formatMailDate = exports.formatDateWithDayOfWeek = exports.formatDateShort = exports.formatDateLong = exports.formatAccount = void 0;
var _dateFns = require("date-fns");
var _es = _interopRequireDefault(require("date-fns/locale/es"));
var _enUS = _interopRequireDefault(require("date-fns/locale/en-US"));
var _helpers = require("./helpers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var locales = {
  es: _es["default"],
  en: _enUS["default"]
};
var dateFormats = {
  es: 'd/M/yy',
  en: 'M/d/yy'
};

/**DATE FORMATTERS */
var formatTweetDate = exports.formatTweetDate = function formatTweetDate(date, lang) {
  return (0, _helpers.isValidDate)(date) && (0, _dateFns.format)(date, "h:mm a '·' PP", {
    locale: locales[lang]
  });
};
/* istanbul ignore next */
var formatTimeLong = exports.formatTimeLong = function formatTimeLong(date, lang) {
  return (0, _helpers.isValidDate)(date) && (0, _dateFns.format)(date, 'p', {
    locale: locales[lang]
  });
};
var formatTimeShort = exports.formatTimeShort = function formatTimeShort(date) {
  return (0, _helpers.isValidDate)(date) && (0, _dateFns.format)(date, 'h:mm a');
};
var formatTimeShort24hrs = exports.formatTimeShort24hrs = function formatTimeShort24hrs(date, lang) {
  return (0, _helpers.isValidDate)(date) && (0, _dateFns.format)(new Date(date), 'HH:mm', {
    locale: locales[lang]
  });
};
var formatDateLong = exports.formatDateLong = function formatDateLong(date, lang) {
  return (0, _helpers.isValidDate)(date) && (0, _dateFns.format)(date, 'PP', {
    locale: locales[lang]
  });
};
var formatDateShort = exports.formatDateShort = function formatDateShort(date, lang) {
  return (0, _helpers.isValidDate)(date) && (0, _dateFns.format)(new Date(date), dateFormats[lang], {
    locale: locales[lang]
  });
};
var formatMailDate = exports.formatMailDate = function formatMailDate(date, lang) {
  return (0, _helpers.isValidDate)(date) && (0, _dateFns.format)(new Date(date), 'PP h:mm a', {
    locale: locales[lang]
  });
};
var formatTimeOrDateShort = exports.formatTimeOrDateShort = function formatTimeOrDateShort(date, lang) {
  return (0, _helpers.isValidDate)(date) && ((0, _dateFns.isToday)(date) ? formatTimeShort(date) : formatDateShort(date, lang));
};
var formatDateWithDayOfWeek = exports.formatDateWithDayOfWeek = function formatDateWithDayOfWeek(date, lang) {
  return (0, _helpers.isValidDate)(date) && (0, _dateFns.format)(date, 'iii d MMMM y', {
    locale: locales[lang]
  });
};

/**OTHERS */
var formatAccount = exports.formatAccount = function formatAccount(account) {
  return account.startsWith('@') ? account : '<' + account + '>';
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/utils/formatters.js
// module id = 83
// module chunks = 0